import React from 'react';

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      fill="none"
      viewBox="0 0 5 5"
      style={{ padding: '0.2rem' }}
    >
      <path
        fill="#262424"
        d="M2.485 4.046c-.476 0-.882-.163-1.218-.49a1.684 1.684 0 01-.49-1.218c0-.485.164-.891.49-1.218A1.66 1.66 0 012.485.616c.486 0 .896.168 1.232.504.336.327.504.733.504 1.218 0 .476-.168.882-.504 1.218a1.7 1.7 0 01-1.232.49z"
      ></path>
    </svg>
  );
}

export default Icon;
